<template>
    <div class="stop-item">
        <md-button
            title="Send Sms to order contact"
            class="md-success"
            :class="useIcon ? 'md-warning md-just-icon md-round' : `${className}`"
            :disabled="!isSmsEnabled"
            @click.stop="showSendSmsModal"
        >
            <span>Sms Contact</span>
        </md-button>
    </div>
</template>

<script>
import { isPhoneValid } from '@/helpers';
import SendSmsModal from '@/pages/Orders/components/SendSmsModal';

export default {
    name: 'SendSmsButton',
    props: {
        orderId: {
            type: Number,
            required: true
        },
        orderContact: {
            type: Object,
            required: true
        },
        className: {
            type: String,
            default: () => ''
        },
        useIcon: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        isSmsEnabled() {
            return this.orderContact && isPhoneValid(this.orderContact.phone);
        }
    },
    methods: {
        showSendSmsModal() {
            this.$modal.show(SendSmsModal, {
                orderId: this.orderId,
                orderContact: this.orderContact
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.stop-item {
    display: inline;
}
</style>
